// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { OnlineCourseFeedbackData } from '../../types/OnlineCourseFeedback';

export interface OnlineCourseFeedbackRequestPayload {
  id: string;
  loadingType: LoadingType;
}
export interface OnlineCourseFeedbackSuccessPayload {
  onlineCourseFeedbackData: OnlineCourseFeedbackData[];
  canReview: boolean;
  id: string;
  loadingType: LoadingType;
}

export interface OnlineCourseFeedbackFailPayload {
  error: Error;
}

export const getOnlineCourseFeedbackActions = createAsyncAction(
  'elearning/GET_ONLINE_COURSE_FEEDBACK',
  'elearning/GET_ONLINE_COURSE_FEEDBACK_SUCCESS',
  'elearning/GET_ONLINE_COURSE_FEEDBACK_FAIL'
)<
  OnlineCourseFeedbackRequestPayload,
  OnlineCourseFeedbackSuccessPayload,
  OnlineCourseFeedbackFailPayload
>();
